import shared from "./shared"

const env = process.env.VUE_APP_ENV || "dev"

const api: { [key: string]: any } = require(`./${env}/api`).default

export default { ...shared, api, env }
